module.exports = __webpack_public_path__ + "img/connections-text-white.39f6f50e.png";